/* eslint-disable camelcase, react-hooks/rules-of-hooks */
import { useMutation } from 'react-query';
import axios from '@utils/axios';
import { useSnackbar } from '@hooks/useSnackbar';

export function useRequestReindexing() {
  const { showMessage } = useSnackbar();
  interface RequestData {
    url: string;
  }

  const mutationFn = async ({ url }: RequestData): Promise<void> => {
    return axios.post(`/api/dashboard/seo/request-reindexing`, {
      url
    });
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      showMessage('Reindexing requested');
    },
    onError: () => {
      console.error('error requesting indexing');
    }
  });
}
